import { render, staticRenderFns } from "./Withdrawal.vue?vue&type=template&id=389b50b8&scoped=true&"
import script from "./Withdrawal.vue?vue&type=script&lang=js&"
export * from "./Withdrawal.vue?vue&type=script&lang=js&"
import style0 from "./Withdrawal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Withdrawal.vue?vue&type=style&index=1&id=389b50b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b50b8",
  null
  
)

export default component.exports